<ds-modal [title]="'switcher' | translate" [headerIcon]="Icons.ListUl">
  <app-switcher-content></app-switcher-content>
</ds-modal>
